import loadable from '@loadable/component';
import Loading from '../components/Loader';

const Offer = loadable(() => import(/* webpackChunkName: "offer" */ '../pages/VoucherOffer'), {
  fallback: Loading
});

export default Offer;
